import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { useState } from "react";
import "../styles/custombtn.css";

function Thumbnail(props) {
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      <Card style={{ width: "18rem" }}>
        <Card.Img
          style={loaded ? {} : { display: "none" }}
          variant="top"
          src={props.img}
          alt={props.alt}
          onLoad={() => setLoaded(true)}
        />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          <Card.Text>{props.description}</Card.Text>
          <Button
            className="btn-cust"
            onClick={() => window.open(`${props.link}`, "_blank")}
          >
            View Project
          </Button>
        </Card.Body>
      </Card>
    </>
  );
}

export default Thumbnail;
